// extracted by mini-css-extract-plugin
export var statItem = "_k7-1";
export var statsRow = "_k7-0";